import React, { Component } from 'react';
import './style.scss';
import QAGroup from '../QAGroup';
import PropTypes from 'prop-types';
import TopicContent from '../topicContent';
import TalkContent from "../talkContent";


class Section extends Component {


    renderTopicContent(topicContent, label) {
        return (
            <div>
                <h5>{label}</h5>
                <TopicContent className={"section-topic"} content={topicContent} />
            </div>
        )
    }

    renderTalkContent(talkContent, label) {
        return (
            <div>
                <h5>{label}</h5>
                <TalkContent className={"section-topic"} content={talkContent} />
            </div>
        )
    }


    renderQuestions(QAs) {
        return (
            <div>
                <h5>Questions: </h5>
                {QAs.map(function (QA, index) {
                    return <QAGroup  className={"section-group"} QA={QA} key={index} index={index}/>
                })}
            </div>)
    }

    renderFollowUpQAs(followUpQAs) {
        return (
            <div>
                <h5>Follow questions: </h5>
                {
                    followUpQAs.map(function (followUpQA, index) {
                        return <QAGroup className={"section-group"} QA={followUpQA} key={index} index={index}/>
                    })
                }
            </div>
        )
    }

    render() {
        if (this.props.section) {
            const { QAs, followUpQAs, label, content, talkContent } = this.props.section;
            return (
                <div className="section">
                    {content && this.renderTopicContent(content, label)}
                    {talkContent && this.renderTalkContent(talkContent, label)}
                    {QAs && QAs.length > 0 && this.renderQuestions(QAs)}
                    {followUpQAs && followUpQAs.length > 0 && this.renderFollowUpQAs(followUpQAs)}
                </div>
            );
        } else {
            return (
                <div>Empty</div>
            )
        }
    }
}


Section.propTypes = {
    section: PropTypes.object.isRequired,
};

export default Section;
